import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import Intro from '../../components/CommunitySections/Intro/Intro'
import Message from '../../components/CommunitySections/Message/Message'
// import Map from '../../components/CommunitySections/Map/Map'
import MapboxMap from '../../components/CommunitySections/MapboxMap/MapboxMap'
import Banner from '../../components/CommunitySections/Banner/Banner'
import TopThree from '../../components/CommunitySections/TopThree/TopThree'
// import LargePhoto from '../../components/UI/LargePhoto/LargePhoto'
// import image from '../../assets/images/community-grand.jpg'
// import image2 from '../../assets/images/volunteer-resized.jpg'
import CommunitySlideshow from "../../components/CommunitySections/CommunitySlideshow/CommunitySlideshow";
import CommunityMessage from '../../components/CommunitySections/CommunityMessage/CommunityMessage'
import NextPage from '../../components/UI/NextPage/NextPage'

class Community extends Component {
  componentDidMount() {
    try {
      window.scroll({
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Dickinson Viewbook | Our Community</title>
        </Helmet>
        <Intro />
        <Message />
        <CommunitySlideshow />
        <Banner />
        <CommunityMessage />
        <MapboxMap />
        <TopThree />
        <NextPage link="/global-opportunities" title="Our Global Opportunities" />
      </React.Fragment>
    );
  }
}

export default Community;
